import qs from "qs";

export const sanitizeLocationSearch = (search) => {
    const { snippet, area, "view-file": viewFile, highlight, ...rest } = qs.parse(search, {
        ignoreQueryPrefix: true,
    });
    return qs.stringify(rest);
};

// Keeps list context (e.g. page) when replacing the view params
export const withViewParams = (search, params) => {
    return "?" + qs.stringify({ ...qs.parse(sanitizeLocationSearch(search)), ...params });
};
